// TODO: double check this.
import { EventType } from "../features/balancing/types/BalancingCore";
export var IdGroupOffers;
(function (IdGroupOffers) {
    // values can be found in balancing: PurchaseOfferGroups.json
    IdGroupOffers["PlayerLeagueOffers"] = "leagueReward{0}POs";
    IdGroupOffers["CoopLeagueOffers"] = "coopLeagueReward{0}POs";
    IdGroupOffers["CollectLeagueOffers"] = "collectLeagueReward{0}POs";
})(IdGroupOffers || (IdGroupOffers = {}));
export var mapEventTypeToIdGroupOffer = new Map([
    [EventType.PlayerLeague, IdGroupOffers.PlayerLeagueOffers],
    [EventType.CoopLeague, IdGroupOffers.CoopLeagueOffers],
    [EventType.CollectLeague, IdGroupOffers.CollectLeagueOffers],
]);



//////////////////
// WEBPACK FOOTER
// ./src/constants/IdGroupOffers.ts
// module id = 2446
// module chunks = 3